module.exports = __webpack_public_path__ + "static/jinx_604w_q50-8bcf4edc596ad70751169499a5b65751.webp";